<template>
  <div class="flags-div has-text-centered">
    <span
      @click="setLocale('pt_BR')"
      class="flag flag-icon flag-icon-br"
    ></span>

    <span
      @click="setLocale('pt_PT')"
      class="flag flag-icon flag-icon-pt"
    ></span>

    <span @click="setLocale('en')" class="flag flag-icon flag-icon-gb"></span>

    <span @click="setLocale('es')" class="flag flag-icon flag-icon-es"></span>
  </div>
</template>

<script>
export default {
  methods: {
    setLocale(l) {
      this.$store.dispatch("setLocale", l).then(() => {
        console.log("Locale set to:", l);
        console.log("Current i18n locale:", this.$i18n.locale);
      });
    }
  }
};
</script>

<style scoped>
.flags-div {
  font-size: 24px;
  margin-bottom: 0.5rem;
}
.flag {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  cursor: pointer;
}
</style>
